<template>
    <div class="container pa-3">
         <v-row>
          <!--Notification Bar-->
          <v-col cols="12">
              <v-alert v-if="message.show" dismissible color="green darken-3" type="info">{{message.text}}</v-alert>
          </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Upcoming Activation</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <dashboard-activation-data-table
            :AM="AM"
            :CC="CC"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Campaign Brief</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <campaign-brief-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Pairing</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <pairing-lineup-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Drafts</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <drafts-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Reporting</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <reporting-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <change-password-modal
      v-model="passwordModalDialog"
      :value="passwordModalDialog"
      @changePassword="passwordChanged"
    ></change-password-modal>
    <view-campaign-modal :modalId="'view_campaign_modal'" v-model="viewCampaignModalDialog" :value="viewCampaignModalDialog" :campaignData="viewCampaignData" />
    </div>
</template>
<script>
/* eslint-disable */
import moment from 'moment';
import { mapState } from 'vuex';
import ChangePasswordModal from '../User/ChangePasswordModal';
import mockUpData from './co_data.json'
import ChartData from './Chart/chart-data.json'
import campaignAPIs from '../Campaign/campaignAPIs';
import userAPIs from '../User/userAPIs';
import config from '@/config';
// Components
import ContentStrategistTasks from '../DashboardComponents/ContentStrategistTasks.vue';
// import PostsSummary from '../DashboardComponents/PostsSummary.vue';
import CampaignSummary from '../DashboardComponents/CampaignSummary.vue';
import totalNumber from '../DashboardComponents/TotalNumbers';
import SpendBarChart from './Chart/Bar.vue';
import BarChart from '../DashboardComponents/Chart/Bar.vue';
import LineChart from '../DashboardComponents/Chart/Line.vue';
import QualityRatingHelper from '../DashboardComponents/QualityRatingHelper'
import SpeedHelper from '../DashboardComponents/SpeedHelper'
import SpendHelper from '../DashboardComponents/SpendHelper'
import KobeOverViewHelper from '../DashboardComponents/KobeOverviewHelper'
import CampaignBriefDataTable from '../DashboardComponents/CampaignBriefDataTable.vue';
import DashboardActivationDataTable from '../DashboardComponents/DashboardActivationDataTable.vue';
import PairingLineupDataTable from '../DashboardComponents/PairingLineupDataTable.vue';
import DraftsDataTable from '../DashboardComponents/DraftsDataTable.vue';
import ReportingDataTable from '../DashboardComponents/ReportingDataTable.vue';
import ViewCampaignModal from '../Campaign/ViewCampaignModal'
export default {
  name: 'CO_Dashboard',
  components: {
    ChangePasswordModal,
    ContentStrategistTasks,
    CampaignSummary,
    totalNumber,
    SpendBarChart,
    BarChart,
    LineChart,
    DashboardActivationDataTable,
    CampaignBriefDataTable,
    PairingLineupDataTable,
    DraftsDataTable,
    ReportingDataTable,
    ViewCampaignModal
  },
  data() {
    return {
      passwordModalDialog: false,
      pwdWarning: false,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      totalSummaryData: {},
      speedChartData: ChartData.Speed,
      spendChartData: ChartData.Spend,
      campaigns: [],
      COUsers: [],
      FilterCOUsers: [],
      benchmark: 4,
      benchmarkColor: {r: 255, g: 99, b: 132},
      yAxes: {
        min: 0,
        max: 5,
        stepSize: 1,
        label: 'Score'
      },
      speedBenchmark: 20,
      speedYAxes: {
        min: 0,
        max: 30,
        stepSize: 5,
        label: 'Days'
      },
      SPEED_TURNAROUND: {
        id: 'campaign_speed_turnaround_chart',
        title: 'Turnaround for Campaign - Filter by',
        labels: [],
        datasets: []
      },
      spendCogsBenchmark: 50,
      spendCogsYAxes: {
        min: 0,
        max: 100,
        stepSize: 10,
        label: 'Percentage'
      },
      SPEND_COGS: {
        id: 'campaign_spend_cogs_chart',
        title: 'COGS - Filter by',
        labels: [],
        datasets: []
      },
      INFLUENCER_SATISFACTION: {
        id: 'influencer_line_chart',
        title: 'Influencer Satisfaction - Filter by',
        labels: [],
        datasets: []
      },
      CLIENT_SATISFACTION: {
        id: 'client_line_chart',
        title: 'CLIENT Satisfaction - Filter by',
        labels: [],
        datasets: []
      },
      influencerPerMonth: 'Total Influencer on ' + moment(Date.now()).format('MMMM'),
      campaignActivity: {
        ACTIVATION: 'activation',
        PAIRING: 'pairing',
        CREATING: 'creating',
        COMPLETE: 'complete'
      },
      viewCampaignData: null,
      viewCampaignModalDialog: false,
      AM: [],
      CC: []
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserRole: function() {
      return this.user.role;
    },
    currentUserID: function() {
      return this.user.id;
    }
  },
  async mounted() {
    this.getUsers()
    this.pwdWarning = this.user.pwdWarning;
    let response
    //get all campaigns
    response = await QualityRatingHelper.getAllCampaignsNoStatus()
    if (response) {
      this.campaigns = response
    }
    // Get all CO by role
    response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
    if (response) {
      this.COUsers = response.users
      this.COUsers = this.COUsers.map(co => {
        co.name = `${co.firstName} ${co.lastName}`
        co.lineColor = this.randomLineColors()
        return co
      })
      this.filterUsers = this.COUsers.slice()
      this.filterUsers.unshift({id: '', name: 'All Team'})
    }
    // this.totalSummaryData = await KobeOverViewHelper.getAMCODashboardTotal()
    this.getSpeedDataOverview({monthly : true})
    this.getInfluencerAvgRatingsOverview({monthly : true})
    // this.getClientAvgRatingsOverview({monthly : true})
    this.getSpendCOGS({monthly: true})
  },
  methods: {
    getSpeedDataOverview(filters) {
      let queryFilter = {}
      if(filters.monthly) { queryFilter.monthly = true }
      if(filters.quarterly) { queryFilter.quarterly = true }
      if(filters.yearly) { queryFilter.yearly = true }
      SpeedHelper
      .getSpeedData('all', queryFilter)
      .then(response => {
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : ''
        let graphdata = this.getSpeedGraphData(response, queryFilter)
        this.SPEED_TURNAROUND.labels = graphdata.periodLabels
        this.SPEED_TURNAROUND.datasets = graphdata.datasets
      })
      .catch(error => {
        // Request failed.
        this.isLoading = false;
        console.log('error', error);
      });
    },
    getInfluencerAvgRatingsOverview(filters) {
      let queryFilter = {}
      if(filters.monthly) { queryFilter.monthly = true }
      if(filters.quarterly) { queryFilter.quarterly = true }
      if(filters.yearly) { queryFilter.yearly = true }
      QualityRatingHelper
      .getInfluencerAvgRating(queryFilter, true)
      .then(response => {
        let avgRates = response.data
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : ''
        let graphdata = this.getSatisfactionGraphData(avgRates, queryFilter)
        this.INFLUENCER_SATISFACTION.labels = graphdata.periodLabels
        this.INFLUENCER_SATISFACTION.datasets = graphdata.datasets
      })
      .catch(error => {
        // Request failed.
        this.isLoading = false;
        console.log('error', error);
      });
    },
    getClientAvgRatingsOverview(filters) {
      let queryFilter = {}
      if(filters.monthly) { queryFilter.monthly = true }
      if(filters.quarterly) { queryFilter.quarterly = true }
      if(filters.yearly) { queryFilter.yearly = true }
      QualityRatingHelper
      .getClientAvgRatings(filters, true)
      .then(response => {
        let clientAvgRatings = response.ratings
        let avgRates = this.calculateClientAvgOverall(clientAvgRatings)
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : ''
        let graphdata = this.getSatisfactionGraphData(avgRates, queryFilter)
        this.CLIENT_SATISFACTION.labels = graphdata.periodLabels
        this.CLIENT_SATISFACTION.datasets = graphdata.datasets
      })
      .catch(error => {
        // Request failed.
        this.isLoading = false;
        console.log('error', error);
      });
    },
    getSpendCOGS(filters) {
      let queryFilter = this.getPeriodFilter(filters)
      SpendHelper
      .getCOGSPerCampaign(queryFilter)
      .then(response => {
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : ''
        let graphdata = this.getSpendGraphData(response, queryFilter)
        this.SPEND_COGS.labels = graphdata.periodLabels
        this.SPEND_COGS.datasets = graphdata.datasets
      })
      .catch(error => {
        // Request failed.
        this.isLoading = false;
        console.log('error', error);
      });
    },
    getSpeedGraphData(data, filters) {
      //find possible periods on all activities
      let allPeriods = []
      Object.keys(this.campaignActivity).map(function(key) {
        allPeriods = data[key].map(a => a.period && a.period)
      })
      let periods = [...new Set(allPeriods.sort())]
      let datasets = []
      let filterCO = []
      //------ get total average speed data based on periods for each CO from all campaign activity days ------//
      if(filters.COUserId !== '') {
        filterCO = this.COUsers.filter(c => c.id === filters.COUserId)
      } else {
        filterCO = this.COUsers
      }
      filterCO.map((co, key) => {
        let eachPeriodData = []
        periods.map(p => {
          let totalDays = 0
          let eachCOAvgDays = 0
          Object.keys(this.campaignActivity).map(function(key) {
            let COCampaigns = data[key].filter(a => a.assignedTo && a.assignedTo.includes(co.id) && a.period === p)
            let days = COCampaigns.map(c => c.days).reduce((one, two) => one + two, 0)
            totalDays += days
          })
          eachCOAvgDays = totalDays > 0 ?  Math.round(totalDays / Object.keys(this.campaignActivity).length, 0) : 0
          eachPeriodData.push(eachCOAvgDays)
        })
        datasets.push({
          'label': co.name,
          'data': eachPeriodData,
          'backgroundColor': co.lineColor,
          'stack': 'Stack ' + (key + 1)
        })
      })
      let benchmarkData = periods.map(p => this.speedBenchmark) //change benchmark value
      datasets.unshift({
        'label': `Benchmark`,
        'data': benchmarkData,
        'backgroundColor': `rgba(${this.benchmarkColor.r}, ${this.benchmarkColor.g}, ${this.benchmarkColor.b})`,
        'stack': 'Stack ' + 0
      })
      let periodLabels = this.ratingPeriodLabels(filters,periods)
      return {periodLabels, datasets}
    },
    getSatisfactionGraphData(avgRates, filters) {
      let periods = [...new Set(avgRates.map(a => a._id.period).sort())]
      let datasets = []
      let filterCO = []
      //------ get total average ratings data based on periods for each CO from all average ratings data ------//
      if(filters.COUserId !== '') {
        filterCO = this.COUsers.filter(c => c.id === filters.COUserId)
      } else {
        filterCO = this.COUsers
      }
      filterCO.map((co, key) => {
        let eachPeriodData = []
        periods.map(p => {
          let COCampaigns = 0
          let eachTotalRate = 0
          avgRates.map(av => {
            if (av._id.period === p) {
              let hasCOInCampaign = this.campaigns.some(c => (c.id === av._id.campaignID && (c.assignedTo && c.assignedTo.includes(co.id))))
              if (hasCOInCampaign) {
                COCampaigns += 1
                eachTotalRate += av.avg_overall
              }
            }
          })
          eachTotalRate = (eachTotalRate > 0 && COCampaigns > 0) ? Math.round(eachTotalRate / COCampaigns) : 0
          eachPeriodData.push(eachTotalRate)
        })
        datasets.push({
          'label': co.name,
          'data': eachPeriodData,
          'borderColor': co.lineColor,
          'fill': false,
          'stack': 'Stack ' + (key + 1)
        })
      })

      let benchmarkData = periods.map(p => this.benchmark) //change benchmark value
      datasets.unshift({
        'label': `Benchmark`,
        'data': benchmarkData,
        'borderColor': `rgba(${this.benchmarkColor.r}, ${this.benchmarkColor.g}, ${this.benchmarkColor.b})`,
        'fill': false,
        'stack': 'Stack ' + 0
      })
      let periodLabels = this.ratingPeriodLabels(filters,periods)
      return {periodLabels, datasets}
    },
    getSpendGraphData(data, filters) {
      //find periods based on filter (monthly, quarterly, yearly)
      let periodResult = this.getCogsCampaignPeriod(data, filters)
      data = periodResult.data
      let periods = periodResult.periods
      let datasets = []
      let filterCO = []
      //------ get average COGS data based on (target, payout) for each CO from COGS per campaign data ------//
      if(filters.COUserId !== '') {
        filterCO = this.COUsers.filter(c => c.id === filters.COUserId)
      } else {
        filterCO = this.COUsers
      }
      filterCO.map((co, key) => {
        let eachPeriodData = []
        periods.map(p => {
          let eachTotalTarget = 0
          let eachTotalPayout = 0
          let eachTotalRate = 0
          data.map(c => {
            c.period.map(dp => {
              if (dp === p) {
                if (c.assignedTo && c.assignedTo.includes(co.id)) {
                  eachTotalTarget += c.budget
                  eachTotalPayout += c.payout
                }
              }
            })
          })
          eachTotalRate = eachTotalPayout > 0 || eachTotalTarget > 0 ? ((eachTotalPayout / eachTotalTarget) * 100).toFixed(2) : 0
          eachPeriodData.push(eachTotalRate)
        })
        datasets.push({
          'label': co.name,
          'data': eachPeriodData,
          'backgroundColor': co.lineColor,
          'stack': 'Stack ' + (key + 1)
        })
      })
      let benchmarkData = periods.map(p => this.spendCogsBenchmark) //change benchmark value
      datasets.unshift({
        'label': `Benchmark`,
        'data': benchmarkData,
        'backgroundColor': `rgba(${this.benchmarkColor.r}, ${this.benchmarkColor.g}, ${this.benchmarkColor.b})`,
        'stack': 'Stack ' + 0
      })
      let periodLabels = this.ratingPeriodLabels(filters,periods)
      return {periodLabels, datasets}
    },
    calculateClientAvgOverall(clientAvgRatings) {
      let avgValues = [
        'avg_influencers_selection',
        'avg_content_quality_rate',
        'avg_campaign_timeline_rate',
        'avg_overall_experience_rate',
        'avg_draft_post'
      ]
      clientAvgRatings = clientAvgRatings.map(v => {
        let totalAvgs = 0
        avgValues.map(akey => {
          v[akey] = v[akey] ? Math.round(v[akey]) : 0
          totalAvgs += v[akey]
        })
        v.avg_overall = Math.round(totalAvgs / avgValues.length)
        return v
      })
      return clientAvgRatings
    },
    getCogsCampaignPeriod(data, filters) {
      let allPeriods = []
      let currentYear = parseInt(moment().format('YYYY'))
      data = data.map(a => {
        a.period = []
        // check start date
        if(a.startDate) {
          let startYear = parseInt(moment(a.startDate).format('YYYY'))
          if(filters.monthly && startYear === currentYear) {
            a.period.push(moment(a.startDate).format('M'))
          }
          else if(filters.quarterly && startYear === currentYear) {
            a.period.push(moment(a.startDate).quarter())
          }
          else if(filters.yearly) {
            a.period.push(moment(a.startDate).format('YYYY'))
          }
        }
        // check end Date
        if(a.endDate) {
          let endYear = parseInt(moment(a.endDate).format('YYYY'))
          if(filters.monthly && endYear === currentYear) {
            a.period.push(moment(a.endDate).format('M'))
          }
          else if(filters.quarterly && endYear === currentYear) {
            a.period.push(moment(a.endDate).quarter())
          }
          else if(filters.yearly) {
            a.period.push(moment(a.endDate).format('YYYY'))
          }
        }
        // check createdAt if not start date and end date
        if(!a.startDate && !a.endDate) {
          let createdYear = parseInt(moment(a.createdAt).format('YYYY'))
          if(filters.monthly && createdYear === currentYear) {
            a.period.push(moment(a.createdAt).format('M'))
          }
          else if(filters.quarterly && createdYear === currentYear) {
            a.period.push(moment(a.createdAt).quarter())
          }
          else if(filters.yearly) {
            a.period.push(moment(a.createdAt).format('YYYY'))
          }
        }
        a.period = [...new Set(a.period)]
        return a
      })
      data = data.filter(d => d.period.length > 0) // filter campaigns with periods
      data.map(a => {
        if (a.period) {
          a.period.map(p => {
            if(p !== 'Invalid date') {
              allPeriods.push(p)
            }
          })
        }
      })
      let periods = [...new Set(allPeriods)].sort((a, b) => a - b)
      if(filters.quarterly) { // add Q symbol for quarterly
        let quarterLabel = this.quarterLabels(periods, data)
        periods = quarterLabel.periods
        data = quarterLabel.data
      }
      return {data, periods}
    },
    ratingPeriodLabels(filters, periods) {
      if (filters.hasOwnProperty('monthly')) {
        return periods.map(p => moment(p, 'MM').format('MMM'))
      }
      return periods
    },
    quarterLabels(periods, data) {
      periods = periods.map(p => 'Q' + p)
      data = data.map(d => {
        if(d.period.length) {
          d.period = d.period.map(p => 'Q' + p)
        } else if(d.period) {
          d.period = 'Q' + d.period
        }
        return d
      })
      return {periods, data}
    },
    randomLineColors() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      if(r === this.benchmarkColor.r && g == this.benchmarkColor.g && b == this.benchmarkColor.b) {
        // if benchmark color, regenerate color
        this.randomLineColors()
      }

      return "rgb(" + r + "," + g + "," + b + ")";
    },
    getPeriodFilter(filters) {
      let queryFilter = {}
      if(filters.monthly) { queryFilter.monthly = true }
      if(filters.quarterly) { queryFilter.quarterly = true }
      if(filters.yearly) { queryFilter.yearly = true }
      return queryFilter
    },
    speedDetail() {
      this.$router.push({name: 'co-speed'})
    },
    satisfactionDetail() {
      this.$router.push({name: 'CO-Quality'})
    },
    spendRevenueDetail() {
      this.$router.push({name: 'co-spend-revenue'})
    },
    async getUsers() {
      try {
        let response = null
        // get clients
        await this.$store.dispatch('client/getClients')
        // Get all AM by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        if (response) {
          this.AM = response.users
          this.AM = this.AM.map(am => {
            am.name = `${am.firstName} ${am.lastName}`
            return am
          })
        }
        this.AM.unshift({id: '', name: 'All Team'})
        // Get all CC by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
        if (response) {
          this.CC = response.users
          this.CC = this.CC.map(cc => {
            cc.name = `${cc.firstName} ${cc.lastName}`
            return cc
          })
          this.CC.unshift({id: '', name: 'All Team'})
        }
      } catch (error) {
        // Request failed.
        console.log('error', error);
        return false
      }
    },
    getCampaignDataToView(campaignID) {
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = response
          this.viewCampaignModalDialog = true
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    }
  }
}
</script>
<style scoped>
  .sub-title {
    font-size: 28px !important;
    font-weight: 300;
  }
</style>




// WEBPACK FOOTER //
// index.vue?14665d52